import './App.css';
import { observer } from "mobx-react-lite";
import React from "react";
import ScaleManager from 'react-sdk/ScaleManager';
import AppState, { POPUPS, SCREENS } from "@/js/AppState";

import ScreenHome from "@scr/ScreenHome/ScreenHome";
import Notifs from "@cmp/shared/Notifs/Notifs";
import ScreenVideo from '@scr/ScreenVideo/ScreenVideo';
import ScreenGame from "@scr/ScreenGame/ScreenGame";
import PopupsManager from 'react-sdk/PopupsManager';
import ScreenModules from '../screens/ScreenModules/ScreenModules';
import ScreenEnd from '../screens/ScreenEnd/ScreenEnd';
import PopupMentionsLegales from '../popups/PopupMentionsLegales/PopupMentionsLegales';
import PopupCredits from '../popups/PopupCredits/PopupCredits';
import LoadingLayer from '../screens/ScreenLoading/LoadingLayer';
import Loading from '@/js/Loading';

const App = () => {
  return (
    <>
      <div className="App"  style={ScaleManager.style}>
        {/* {AppState.screen === SCREENS.LOADING && <ScreenLoading />} */}

        {AppState.screen === SCREENS.HOME && <ScreenHome userData={AppState.vertxClient.UserData} saveData={AppState.currentSave}/>}
        {AppState.screen === SCREENS.MODULES && <ScreenModules />}

        {AppState.screen === SCREENS.VIDEO && <ScreenVideo />}
        {AppState.screen === SCREENS.GAME && <ScreenGame />}
        
        {AppState.screen === SCREENS.ECRAN_FINAL && <ScreenEnd />}


        {PopupsManager.isOpened(POPUPS.MENTIONS_LEGALES) &&
        <PopupMentionsLegales />}

        {PopupsManager.isOpened(POPUPS.CREDITS) &&
        <PopupCredits />}

        <Notifs />
        <LoadingLayer visible={Loading.visible} transitionEnd={Loading.animDone} />
      </div>
    </>
  )
}

export default observer(App);
